import {createContext, useContext} from 'react';

import type {KyInstance} from 'ky';

const BlobApiContext = createContext<KyInstance | null>(null);

type Props = {
  blobApi: KyInstance;
  children: React.ReactNode;
};

export function BlobApiProvider({blobApi, children}: Props): React.JSX.Element {
  return (
    <BlobApiContext.Provider value={blobApi}>
      {children}
    </BlobApiContext.Provider>
  );
}

export function useBlobApi(): KyInstance {
  const api = useContext(BlobApiContext);
  if (!api) {
    throw new Error('useBlobApi must be used within a BlobApiProvider');
  }
  return api;
}

BlobApiProvider.displayName = 'BlobApiProvider';
